import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';

const PoliticaPrivacidad = () => (
  <LegalPageTemplate title="Política de Privacidad" description="Política de privacidad de Nubia Solar.">
    <p>En Nubia Solar tratamos los datos personales facilitados a través del formulario de contacto con la finalidad de responder solicitudes de información, preparar presupuestos y mantener comunicaciones relacionadas con nuestros servicios.</p>
    <h2>Responsable del tratamiento</h2>
    <p>Nubia Solar. Email de contacto: info@nubiasolar.com.</p>
    <h2>Datos que tratamos</h2>
    <ul>
      <li>Nombre</li>
      <li>Email</li>
      <li>Teléfono</li>
      <li>Ubicación</li>
      <li>Mensaje o información sobre el proyecto</li>
    </ul>
    <h2>Base jurídica</h2>
    <p>La base legal del tratamiento es el consentimiento del usuario al enviar el formulario y solicitar información comercial o técnica sobre nuestros servicios.</p>
    <h2>Conservación</h2>
    <p>Los datos se conservarán durante el tiempo necesario para atender la solicitud y, en su caso, para gestionar la relación comercial derivada.</p>
    <h2>Derechos</h2>
    <p>Puedes solicitar acceso, rectificación, supresión, oposición o limitación del tratamiento escribiendo a info@nubiasolar.com.</p>
  </LegalPageTemplate>
);

export default PoliticaPrivacidad;
